import { PartnerCapabilities } from "../capabilities";
import { SectionKey } from "../sections";
import { Member, Product, Projection } from "../../../utils/partnerMetrics";

export interface PageProps {
  members: Member[];
  products: Product[];
  capabilities: PartnerCapabilities;
  businessId?: string;
  loading: boolean;
  projection: Projection | null;
  projectionLoading: boolean;
  onNavigate: (key: SectionKey) => void;
  onRefresh: () => void;
}

export const formatDate = (iso?: string | null) =>
  iso
    ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    : "—";

export const daysLabel = (days: number) => {
  if (isNaN(days)) return "—";
  if (days < 0) return "Ended";
  if (days === 0) return "Today";
  return `${days} day${days === 1 ? "" : "s"}`;
};
